

<a href="/some-page"><img src="src/assets/img/bg-masthead.jpg" class="oversize" /></a>
<h1>Hi {{currentUser.firstName}}!</h1>
<ul>
    <li *ngFor="let user of users">
        {{user.username}} ({{user.firstName}} {{user.lastName}})
         <a (click)="deleteUser(user.id)" class="text-danger">Delete</a>
    </li>
</ul>


